import { ICaThiActionTypes } from "../../action-types/tct/ICaThiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ICaThiReducer } from "../../reducer-model/tct/ICaThiReducer";

const iniState: ICaThiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  caThis: [],
  selectedIds: []
};
export const caThiReducer = (
  state: ICaThiReducer = iniState,
  action: ICaThiActionTypes
): ICaThiReducer => {
  switch (action.type) {
    case "CA_THI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "CA_THI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        caThis: action.payload,
        selectedIds: []
      };
    case "CA_THI_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "CA_THI_SHOW_EDIT_MODAL":
      return {
        ...state,
        caThiEditing: action.payload,
        isShowEditModal: true
      };
    case "CA_THI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false
      };
    case "CA_THI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving
      };
    case "CA_THI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "CA_THI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "CA_THI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting
      };
    case "CA_THI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload
      };
    case "CA_THI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed
      };
    case "CA_THI_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload
      };
    default:
      return state;
  }
};
